<template>
  <div
    v-if="aiSummaryTopic || summaryTopicHistory"
    class="tw:group tw:grid tw:gap-2"
    :data-index="dataIndex"
    :data-testid="`cluster-${dataIndex}`"
  >
    <div class="tw:flex tw:items-center tw:overflow-hidden">
      <div class="tw:flex tw:flex-1 tw:gap-1 tw:overflow-hidden">
        <EllipseContent class="tw:font-bold">
          {{ topicTitle }}
        </EllipseContent>
        <div class="tw:text-denim-600">({{ topicMentionCount }})</div>
      </div>
      <div class="tw:hidden tw:pl-2 tw:group-hover:flex">
        <button
          class="tw:m-0 tw:flex tw:cursor-pointer tw:border-none tw:bg-transparent tw:p-0 tw:text-xs tw:text-denim-600 tw:hover:text-blue-700"
          @click="showSummaryCluster()"
        >
          <span>
            {{
              getLocaleText("ai_summary_stream_response.view_included_articles")
            }}
          </span>
          <BaseIcon icon="chevron-right" />
        </button>
      </div>
    </div>
    <div class="tw:leading-tight">
      {{ topicSummary }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from "pinia";
import { computed } from "vue";

import { getLocaleText } from "shared/boot/i18n";
import { BaseIcon } from "shared/components/base";
import EllipseContent from "shared/components/base/EllipseContent.vue";
import useAIStore, {
  type AISummary,
  type AISummaryResultTopic,
} from "shared/stores/ai";

interface AISummaryStreamClusterProps {
  assistant?: boolean;
  dataIndex: number;
  streamId: number;
  topicId: number;
  summaryTopicHistory?: AISummaryResultTopic;
}

const props = defineProps<AISummaryStreamClusterProps>();

const aiStore = useAIStore();
const { openAIModal, getAISummary } = aiStore;
const { aiSummarySelectedTopic, aiSummaryStreamId } = storeToRefs(aiStore);

const aiStreamSummary = computed<Required<AISummary>>(() =>
  getAISummary(props.streamId)
);

const aiSummaryTopic = computed<AISummaryResultTopic | undefined>(() =>
  aiStreamSummary.value.result?.topics.find(
    (topic) => topic.id === props.topicId
  )
);

const topicTitle = computed(() => {
  if (props.summaryTopicHistory) {
    return props.summaryTopicHistory.title;
  }

  return aiSummaryTopic.value?.title;
});

const topicMentionCount = computed(() => {
  if (props.summaryTopicHistory) {
    return props.summaryTopicHistory.mentionsCount;
  }

  return aiSummaryTopic.value?.mentionsCount;
});

const topicSummary = computed(() => {
  if (props.summaryTopicHistory) {
    return props.summaryTopicHistory.summary;
  }

  return aiSummaryTopic.value?.summary;
});

function showSummaryCluster() {
  aiSummaryStreamId.value = props.streamId;

  aiSummarySelectedTopic.value = {
    assistant: props.assistant,
    topicId: props.topicId,
  };

  openAIModal("AISummaryClusterPanel");
}
</script>
